// Hosts aceitos para imagens de produto nos cards (2026-10-14).
//
// Mesma lista do next.config.mjs (images.remotePatterns): o WordPress da loja
// e o Cloudflare R2 (img.persimateriais.com.br), para onde as imagens são
// trocadas quando IMAGE_SOURCE=r2 (lib/media/r2ImageRewrite.ts). Sem o R2
// aqui, os cards que validam o host caíam na imagem padrão da marca.
const WORDPRESS_IMAGE_HOST = "loja.persimateriais.com.br";
const R2_IMAGE_HOST = "img.persimateriais.com.br";
const R2_IMAGE_PATH_PREFIX = "/wp-content/uploads/";
// Fotos enviadas direto ao R2 (2026-10-16, lib/media/r2ProductImages.ts):
// importação do Olist (products/olist/...) e upload do editor de produtos
// (products/uploads/...). Também liberado no next.config.mjs.
const R2_PRODUCT_IMAGE_PATH_PREFIX = "/products/";

export function isAllowedProductImageUrl(value: string): boolean {
  let url: URL;
  try {
    url = new URL(value);
  } catch {
    return false;
  }
  if (url.protocol !== "https:" || url.username || url.password) return false;
  if (url.hostname === WORDPRESS_IMAGE_HOST) return true;
  if (url.hostname !== R2_IMAGE_HOST) return false;
  return url.pathname.startsWith(R2_IMAGE_PATH_PREFIX) || url.pathname.startsWith(R2_PRODUCT_IMAGE_PATH_PREFIX);
}
